export const updateThemeColor = (color, color2) => {
  document.documentElement.style.setProperty('--theme-color', color)
  document.documentElement.style.setProperty('--hover-color', color2)
}
// google ads
export const googleAdsInit = (dom, ads) => {
  const adsStore = document.getElementById(dom)
  if (adsStore) {
    adsStore.innerHTML = ''
    const range = document.createRange()
    range.selectNodeContents(adsStore)
    range.collapse(false)
    const fragment = range.createContextualFragment(ads)
    adsStore.appendChild(fragment)
  }
}

export function addOrUpdateQueryParam(key, value) {
  const urlObj = new URL(window.location.href)
  urlObj.searchParams.set(key, value) // 设置或更新 `page` 参数
  return urlObj.toString() // 返回更新后的 URL 字符串
}

export function updateQueryParam(key, value) {
  const urlObj = new URL(window.location.href)

  if (value === '') {
    urlObj.searchParams.delete(key) // 如果值为空，删除该查询参数
  } else {
    urlObj.searchParams.set(key, value) // 否则，添加或更新查询参数
  }

  return urlObj.toString()
}

// crm 埋点
export function crmTrack(type, refer, channel_id) {
  var postParams = {
    channel_id: channel_id,
    token: refer,
    type: type,
  }
  fetch('https://crm.heomai.com/api/user/action', {
    body: JSON.stringify(postParams),
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
  })
}

function formatNumberWithCommas(number) {
  if (isNaN(number)) return 'Invalid number'
  return Number(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export async function cartDataInit(cartData) {
  // 遍历cartData.items 下的product.url_key == shipping-fee，返回true
  const shippingFeeItem = cartData.items.some((item) => item.product.url_key === 'shipping-fee')
  const res = await getSiteConfig({ config: 'sales.carriers.flatrate.default_rate' })
  const shipping = shippingFeeItem ? 0 : res.data['sales.carriers.flatrate.default_rate']

  cartData.items.forEach((item) => {
    const currentPrice = (parseFloat(item.base_total) - parseFloat(item.base_discount_amount)).toFixed(2)
    const currentPrice_format = formatNumberWithCommas(currentPrice)
    item.currentPrice = `${cartData.currency_symbol}${currentPrice_format}`
    const unitPrice = (currentPrice / item.quantity).toFixed(2)
    item.unitPrice = `${cartData.currency_symbol}${unitPrice}`
    let total_price = ''
    if (cartData.shipping_method) {
      total_price = Number(cartData.base_grand_total).toFixed(2)
    } else {
      total_price = (Number(cartData.base_grand_total) + Number(shipping)).toFixed(2)
    }
    const total_price_format = formatNumberWithCommas(total_price)
    const jp_Taxes = (Number(total_price) - Number(total_price) / 1.1).toFixed(2)
    const jp_Taxes_format = formatNumberWithCommas(jp_Taxes)
    item.jp_Taxes = `${cartData.currency_symbol}${jp_Taxes_format}`
    item.total_price = `${cartData.currency_symbol}${total_price_format}`
    item.shipping = `${cartData.currency_symbol}${shipping}`
  })
}

export function formatPrice(input) {
  // 尝试将输入转换为数字
  const number = Number(input)

  // 检查是否是有效数字
  if (isNaN(number)) {
    console.error('Invalid number:', input)
    return 'Invalid number'
  }

  // 去掉小数点，取整
  const roundedNumber = Math.floor(number)

  // 格式化为带千分位的数字
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0, // 不保留小数
  }).format(roundedNumber)
}
